import { defineComponent as _defineComponent } from 'vue'
import Vue, { ref, onMounted, computed, watch } from 'vue';
import { getGoogleMapsAPI } from 'gmap-vue';

interface Props {
  markers: any[];
  activeMarker?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppMap',
  props: {
    markers: null,
    activeMarker: null
  },
  emits: ["update:activeMarker"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:activeMarker', data: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  markers: any[];
  activeMarker?: number;
};

const ZOOM = 17;




const map = ref(null);
const google = computed(() => getGoogleMapsAPI());
const fitMarkersBounds = (m, markers) => {
  const bounds = new google.value.maps.LatLngBounds();
  markers.forEach((marker) => {
    bounds.extend(new google.value.maps.LatLng(marker.position));
  });
  m.fitBounds(bounds);
  if (markers.length < 2) m.setZoom(ZOOM);
};
onMounted(async () => {
  await Vue.$gmapApiPromiseLazy();
  fitMarkersBounds(map.value.$mapObject, props.markers);
});

watch(
  () => props.markers,
  () => {
    fitMarkersBounds(map.value.$mapObject, props.markers);
  },
);

const center = ref({ lat: 0, lng: 0 });
const setCenter = (index: number) => {
  emit('update:activeMarker', index);
};

watch(
  () => props.activeMarker,
  (value) => {
    if (value === null) return;
    map.value.$mapObject.panTo(props.markers[value].position);
    map.value.$mapObject.setZoom(ZOOM);
  },
);

return { __sfc: true,ZOOM, props, emit, map, google, fitMarkersBounds, center, setCenter }
}

})